import Manager from '@/models/Manager'
import Service from '@/models/Service'
import Staff from '@/models/Staff'
import Announcement from '@/models/Announcement'
import Board from '@/models/Board'
import CallRecord from '@/models/CallRecord'
import Floor from '@/models/Floor'
import Room from '@/models/Room'
import ServiceEvent from '@/models/ServiceEvent'
import ClassInfo from '@/models/ClassInfo'
import OperationRecord from '@/models/OperationRecord'

export const getAnnouncement = async (id: string) => {
  // return fetch('')
  //   .then(function (response) {
  //     return response.json()
  //   })
  //   .then(function (obj) {
  //     return obj.data.items as Announcement[]
  //   })
  return {
    id: id,
    begin: new Date('2020/01/01'),
    end: new Date('2020/12/31'),
    content: 'xxxx',
    places: ['A101', 'A102'],
    templateId: '1'
  }
}

const host = '/1'

const post = async (path: string, formData: URLSearchParams) => {
  const headers: HeadersInit = {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  }
  if (window.localStorage.access_token) {
    headers.Authorization = `Bearer ${window.localStorage.access_token}`
  }
  const obj = await fetch(host + path, {
    body: formData,
    method: 'POST',
    headers: headers
  })
  return obj
}

const upload = async (path: string, formData: FormData) => {
  const headers: HeadersInit = {}
  if (window.localStorage.access_token) {
    headers.Authorization = `Bearer ${window.localStorage.access_token}`
  }
  const obj = await fetch(host + path, {
    body: formData,
    method: 'POST',
    headers: headers
  })
  return obj
}

const get = async (path: string, formData: URLSearchParams = new URLSearchParams()) => {
  const headers: HeadersInit = {}
  if (window.localStorage.access_token) {
    headers.Authorization = `Bearer ${window.localStorage.access_token}`
  }
  const queries: string[] = []
  formData.forEach((v, k) => {
    queries.push(`${k}=${v}`)
  })

  const obj = await fetch(host + path + `?${queries.join('&')}`, {
    method: 'GET',
    headers: headers
  })
  return obj
}

export const login = async (account: string, password: string) => {
  const formData = new URLSearchParams()
  formData.append('grant_type', 'password')
  formData.append('username', account)
  formData.append('password', password)

  const obj = await post('/token', formData)
    .then(res => res.json())

  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return obj
}

export const getManagerList = async (): Promise<Manager[]> => {
  const obj = await get('/users')
    .then(res => res.json())

  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return obj.data.items.map((it: any) => new Manager(it.user_id, it.display_name, it.username))
}

export const getManager = async (id: string): Promise<Manager> => {
  const obj = await get(`/users/${id}`)
    .then(res => res.json())

  if (obj.error) {
    throw new Error(obj.error_description)
  }
  const it = obj.data
  return new Manager(it.user_id, it.display_name, it.username)
}

export const createManager = async (account: string, password: string, name: string) => {
  const formData = new URLSearchParams()
  formData.append('action', 'add-user')
  formData.append('display_name', name)
  formData.append('username', account)
  formData.append('password', password)
  const obj = await post('/users', formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
}

export const importManager = async (file: File) => {
  const formData = new FormData()
  formData.append('action', 'batch-add-users')
  formData.append('file', file)
  const obj = await upload('/users', formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
}

export const updateManager = async (id: string, account: string, password: string, name: string) => {
  const formData = new URLSearchParams()
  formData.append('action', 'update-user')
  formData.append('display_name', name)
  formData.append('username', account)
  formData.append('new_password', password)
  const obj = await post(`/users/${id}`, formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
}

export const deleteManager = async (id: string) => {
  const formData = new URLSearchParams()
  formData.append('action', 'delete-user')
  const obj = await post(`/users/${id}`, formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return true
}

export const getServiceList = async (): Promise<Service[]> => {
  const obj = await get('/services')
    .then(res => res.json())

  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return obj.data.items.map((it: any) => new Service(it.service_id, it.display_name))
}

export const getService = async (id: string): Promise<Service> => {
  const obj = await get(`/services/${id}`)
    .then(res => res.json())

  if (obj.error) {
    throw new Error(obj.error_description)
  }
  const it = obj.data
  return new Service(it.service_id, it.display_name)
}

export const createService = async (name: string) => {
  const formData = new URLSearchParams()
  formData.append('action', 'add-service')
  formData.append('display_name', name)
  const obj = await post('/services', formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
}

export const importService = async (file: File) => {
  const formData = new FormData()
  formData.append('action', 'batch-add-services')
  formData.append('file', file)
  const obj = await upload('/services', formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
}

export const updateService = async (id: string, name: string) => {
  const formData = new URLSearchParams()
  formData.append('action', 'update-service')
  formData.append('display_name', name)
  const obj = await post(`/services/${id}`, formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
}

export const deleteService = async (id: string) => {
  const formData = new URLSearchParams()
  formData.append('action', 'delete-service')
  const obj = await post(`/services/${id}`, formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return true
}

export const getStaffList = async (): Promise<Staff[]> => {
  const obj = await get('/staff')
    .then(res => res.json())

  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return obj.data.items.map((it: any) => {
    const serviceItems = it.service_items.map((s: any) => new Service(s.service_id, s.display_name))
    return new Staff(it.staff_id, it.display_name, serviceItems)
  })
}

export const getStaff = async (id: string): Promise<Staff> => {
  const obj = await get(`/staff/${id}`)
    .then(res => res.json())

  if (obj.error) {
    throw new Error(obj.error_description)
  }
  const it = obj.data
  const serviceItems = it.service_items.map((s: any) => new Service(s.service_id, s.display_name))
  return new Staff(it.staff_id, it.display_name, serviceItems)
}

export const createStaff = async (id: string, name: string, services: string[]) => {
  const formData = new URLSearchParams()
  formData.append('action', 'add-staff')
  formData.append('staff_id', id)
  formData.append('display_name', name)
  formData.append('service_name_list', services.join(';'))
  const obj = await post('/staff', formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
}

export const importStaff = async (file: File) => {
  const formData = new FormData()
  formData.append('action', 'batch-add-staff')
  formData.append('file', file)
  const obj = await upload('/staff', formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
}

export const updateStaff = async (id: string, name: string, services: string[]) => {
  const formData = new URLSearchParams()
  formData.append('action', 'update-staff')
  formData.append('display_name', name)
  formData.append('service_name_list', services.join(';'))
  const obj = await post(`/staff/${id}`, formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
}

export const deleteStaff = async (id: string) => {
  const formData = new URLSearchParams()
  formData.append('action', 'delete-staff')
  const obj = await post(`/staff/${id}`, formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return true
}

export const getServiceEvent = async (begin: Date, end: Date, roomId = ''): Promise<ServiceEvent[]> => {
  console.log(`query service event between ${begin} and ${end}, roomId = ${roomId}`)
  const formData = new URLSearchParams()
  formData.append('room_id', roomId)
  formData.append('not_before', begin.toISOString())
  formData.append('not_after', end.toISOString())
  const obj = await get(`/service-events`, formData)
    .then(res => res.json())

  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return obj.data.items.map((it: any) => {
    const t = new ServiceEvent(it.service_event_id)
    t.roomId = it.room_id
    t.serviceId = it.service_id
    t.staffId = it.staff_id
    t.status = it.status
    t.createdAt = new Date(it.created_at)
    t.confirmedAt = new Date(it.confirmed_at)
    t.checkInAt = new Date(it.check_in_at)
    t.closedAt = new Date(it.closed_at)
    t.note = it.note
    return t
  })
}

export const confirmServiceEvent = async (serviceEventId: string): Promise<object> => {
  const formData = new URLSearchParams()
  formData.append('action', 'confirm')
  const obj = await post(`/service-events/${serviceEventId}`, formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return obj
}

export const closeServiceEvent = async (serviceEventId: string, note: string): Promise<object> => {
  const formData = new URLSearchParams()
  formData.append('action', 'close-service-event')
  formData.append('note', note)
  const obj = await post(`/service-events/${serviceEventId}`, formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return obj
}

export const deleteServiceEvent = async (serviceEventId: string): Promise<object> => {
  const formData = new URLSearchParams()
  formData.append('action', 'delete-service-event')
  const obj = await post(`/service-events/${serviceEventId}`, formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return obj
}

export const getBroadcastItemList = async (): Promise<Announcement[]> => {
  const obj = await get('/broadcast-items')
    .then(res => res.json())

  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return obj.data.items.map((it: any) => new Announcement(it.broadcast_item_id, it.display_name))
}

export const getBroadcastItem = async (id: string): Promise<Announcement> => {
  const obj = await get(`/broadcast-items/${id}`)
    .then(res => res.json())

  if (obj.error) {
    throw new Error(obj.error_description)
  }
  const it = obj.data
  const ret = new Announcement(it.broadcast_item_id, it.display_name)
  ret.begin = new Date(it.not_before)
  ret.end = new Date(it.not_after)
  ret.content = it.content
  ret.contentType = it.content_type
  ret.title = it.title
  ret.boardList = it.board_list
  ret.templateId = it.template_id
  ret.imageId = it.image_id
  return ret
}

export const createBroadcastItem = async (name: string, contentType: string, title: string, content: string, imageId: string, borderList: Array<string>, begin: Date, end: Date, templateId: string) => {
  const formData = new URLSearchParams()
  formData.append('action', 'add-broadcast-item')
  formData.append('display_name', name)
  formData.append('content_type', contentType)
  formData.append('title', title)
  formData.append('content', content)
  formData.append('image_id', imageId)
  formData.append('board_id_list', borderList.join(';'))
  formData.append('not_before', begin.toISOString())
  formData.append('not_after', end.toISOString())
  formData.append('template_id', templateId)
  const obj = await post('/broadcast-items', formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
}

export const updateBroadcastItem = async (id: string, name: string, contentType: string, title: string, content: string, imageId: string, borderList: Array<string>, begin: Date, end: Date, templateId: string) => {
  const formData = new URLSearchParams()
  formData.append('action', 'update-broadcast-item')
  formData.append('display_name', name)
  formData.append('content_type', contentType)
  formData.append('title', title)
  formData.append('content', content)
  formData.append('image_id', imageId)
  formData.append('board_id_list', borderList.join(';'))
  formData.append('not_before', begin.toISOString())
  formData.append('not_after', end.toISOString())
  formData.append('template_id', templateId)
  const obj = await post(`/broadcast-items/${id}`, formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
}

export const deleteBroadcastItem = async (id: string) => {
  const formData = new URLSearchParams()
  formData.append('action', 'delete-broadcast-item')
  const obj = await post(`/broadcast-items/${id}`, formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return true
}

export const getBoardList = async (): Promise<Board[]> => {
  const obj = await get('/boards')
    .then(res => res.json())

  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return obj.data.items.map((it: any) => {
    const r = new Board(it.board_id, it.display_name)
    r.shouldShow = it.should_show
    it.user_list.forEach((it: string) => {
      r.addUserId(it)
    })
    return r
  })
}

export const setBoardPermission = async (boardId: string, userId: string, allow: boolean) => {
  const formData = new URLSearchParams()
  formData.append('action', allow ? 'add-user' : 'delete-user')
  formData.append('user_id', userId)
  const obj = await post(`/boards/${boardId}`, formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
}

export const uploadBroadcastImages = async (file: File): Promise<string> => {
  const formData = new FormData()
  formData.append('action', 'upload-image')
  formData.append('image', file)
  const obj = await upload('/broadcast-images', formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
  const imageId = obj.data.image_id
  return imageId
}

export const generateBroadcastImages = async (templateId: string, title: string, content: string): Promise<string> => {
  const formData = new FormData()
  formData.append('action', 'generate-image')
  formData.append('template_id', templateId)
  formData.append('title', title)
  formData.append('content', content)
  const obj = await upload('/broadcast-images', formData)
    .then(res => res.json())
  if (obj.error) {
    throw new Error(obj.error_description)
  }
  const imageId = obj.data.image_id
  return imageId
}

export const getCallRecordList = async (begin: Date, end: Date, roomId = ''): Promise<CallRecord[]> => {
  // return [new CallRecord(begin, roomId, 'connected')]
  console.log(`query call recoreds between ${begin} and ${end}, roomId = ${roomId}`)
  const formData = new URLSearchParams()
  formData.append('not_before', begin.toISOString())
  formData.append('not_after', end.toISOString())
  formData.append('room_id', roomId)
  const obj = await get(`/call-records`, formData)
    .then(res => res.json())

  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return obj.data.items.map((it: any) => new CallRecord(new Date(it.time), it.room_id, it.status))
}

export const getClassInfoList = async (begin: Date, end: Date, roomId = ''): Promise<ClassInfo[]> => {
  console.log(`query call recoreds between ${begin} and ${end}, roomId = ${roomId}`)
  const formData = new URLSearchParams()
  formData.append('not_before', begin.toISOString())
  formData.append('not_after', end.toISOString())
  const obj = await get(`/room-schedule/${roomId}`, formData)
    .then(res => res.json())

  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return obj.data.items.map((it: any) => new ClassInfo(it.display_name, it.begin_time, it.end_time, it.teacher_display_name))
}

export const getFloorList = async (): Promise<Floor[]> => {
  const obj = await get('/floors')
    .then(res => res.json())

  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return obj.data.items.map((it: any) => new Floor(it.floor_id, it.display_name))
}

export const getRoomList = async (floorId: string): Promise<Room[]> => {
  const obj = await get(`/floors/${floorId}`)
    .then(res => res.json())

  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return obj.data.items.map((it: any) => new Room(it.room_id, it.display_name))
}

export const setEnvironment = async (roomId: string, mode: string, begin: Date, end: Date) => {
  const formData = new URLSearchParams()
  formData.append('action', 'set-parameter')
  formData.append('room_id', roomId)
  formData.append('mode', mode)
  formData.append('not_after', end.toISOString())
  formData.append('not_before', begin.toISOString())

  const obj = await post('/environment', formData)
    .then(res => res.json())

  if (obj.error) {
    throw new Error(obj.error_description)
  }
  return obj.access_token
}

export const getOperationRecord = async (account: string, begin: Date, end: Date): Promise<OperationRecord> => {
  const formData = new URLSearchParams()
  formData.append('username', account)
  formData.append('not_before', begin.toISOString())
  formData.append('not_after', end.toISOString())
  const obj = await get(`/operation-records`, formData)
    .then(res => res.json())

  if (obj.error) {
    throw new Error(obj.error_description)
  }
  const r = new OperationRecord(obj.data.user.username, obj.data.user.display_name)
  obj.data.items.forEach((it: any) => {
    r.addLog(it.time, it.event_description)
  })
  return r
}

export const getTemplateList = async () => {
  return [
    {
      id: '1',
      name: '樣板一',
      content: `${window.location.protocol}//${window.location.host}/templet-1.png`
    },
    {
      id: '2',
      name: '樣板二',
      content: `${window.location.protocol}//${window.location.host}/templet-2.png`
    },
    {
      id: '3',
      name: '樣板三',
      content: `${window.location.protocol}//${window.location.host}/templet-3.png`
    }
  ]
}

export default {
  login,
  getAnnouncement,
  getTemplateList,
  getManagerList,
  getManager,
  createManager,
  importManager,
  updateManager,
  deleteManager,
  getServiceList,
  getService,
  createService,
  importService,
  updateService,
  deleteService,
  getStaffList,
  getStaff,
  createStaff,
  importStaff,
  updateStaff,
  deleteStaff,
  getServiceEvent,
  confirmServiceEvent,
  closeServiceEvent,
  deleteServiceEvent,
  getBroadcastItemList,
  getBroadcastItem,
  createBroadcastItem,
  updateBroadcastItem,
  deleteBroadcastItem,
  getBoardList,
  setBoardPermission,
  uploadBroadcastImages,
  generateBroadcastImages,
  getCallRecordList,
  getClassInfoList,
  getFloorList,
  getRoomList,
  setEnvironment,
  getOperationRecord
}
